import { Outlet } from 'react-router';

import { Toaster } from '../ui/toaster';

function AWALayoutV2() {
  return (
    <div className="bg-grey-1 flex w-full min-w-[320px] flex-1 flex-col items-center">
      <div className="flex w-full max-w-[414px] items-center justify-center sm:max-w-[800px]">
        <Outlet />
      </div>

      <Toaster />
    </div>
  );
}

export default AWALayoutV2;
